export const subcourseConstants = {
  GET_SUBCOURSE_REQUEST: "GET_SUBCOURSE_REQUEST",
  GET_SUBCOURSE_SUCCESS: "GET_SUBCOURSE_SUCCESS",
  GET_SUBCOURSE_FAILURE: "GET_SUBCOURSE_FAILURE",

  UPDATE_SUBCOURSE_REQUEST: "UPDATE_SUBCOURSE_REQUEST",
  UPDATE_SUBCOURSE_SUCCESS: "UPDATE_SUBCOURSE_SUCCESS",
  UPDATE_SUBCOURSE_FAILURE: "UPDATE_SUBCOURSE_FAILURE",

  UPDATE_SUBCOURSE_NAME_REQUEST: "UPDATE_SUBCOURSE_NAME_REQUEST",
  UPDATE_SUBCOURSE_NAME_SUCCESS: "UPDATE_SUBCOURSE_NAME_SUCCESS",
  UPDATE_SUBCOURSE_NAME_FAILURE: "UPDATE_SUBCOURSE_NAME_FAILURE",

  UPDATE_SUBCOURSE_CODE_REQUEST: "UPDATE_SUBCOURSE_CODE_REQUEST",
  UPDATE_SUBCOURSE_CODE_SUCCESS: "UPDATE_SUBCOURSE_CODE_SUCCESS",
  UPDATE_SUBCOURSE_CODE_FAILURE: "UPDATE_SUBCOURSE_CODE_FAILURE",

  MOVE_SUBCOURSE_REQUEST: "MOVE_SUBCOURSE_REQUEST",
  MOVE_SUBCOURSE_SUCCESS: "MOVE_SUBCOURSE_SUCCESS",
  MOVE_SUBCOURSE_FAILURE: "MOVE_SUBCOURSE_FAILURE"
}
